<template>
  <div class="app-container">
    <!-- 统计数据 -->
    <el-row :gutter="10">
      <el-col :xs="12" :sm="12" :lg="6" class="card-box">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-view">
            <svg-icon icon-class="view-count"  class-name="card-panel-icon"/>
          </div>
          <div class="card-desc">
            <div class="card-title">访问数量</div>
            <count-to :start-val="0" :end-val="viewsCount || 0" :duration="2600" class="card-count" />
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-box">
        <div  class="card-panel">
          <div class="card-panel-icon-wrapper icon-comment">
            <svg-icon icon-class="comment-count" class-name="card-panel-icon"/>
          </div>
          <div class="card-desc">
            <div class="card-title">留言数量</div>
            <count-to :start-val="0" :end-val="messageCount || 0" :duration="2600" class="card-count" />
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-box">
        <div  class="card-panel">
          <div class="card-panel-icon-wrapper icon-user">
            <svg-icon icon-class="user-count" class-name="card-panel-icon"/>
          </div>
          <div class="card-desc">
            <div class="card-title">用户数量</div>
            <count-to :start-val="0" :end-val="userCount || 0" :duration="2600" class="card-count" />
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-box">
        <div  class="card-panel">
          <div class="card-panel-icon-wrapper icon-article">
            <svg-icon icon-class="article-count" class-name="card-panel-icon"/>
          </div>
          <div class="card-desc">
            <div class="card-title">文章数量</div>
            <count-to :start-val="0" :end-val="articleCount || 0" :duration="2600" class="card-count" />
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 一周访问量展示 -->
    <el-card class="card-box">
      <div class="e-title">一周访问量</div>
      <div style="height:350px" ref="weekViewCount"></div>
    </el-card>
    <el-row :gutter="10" >
      <!-- 文章浏览量排行 -->
      <el-col :xs="24" :sm="24" :lg="16" class="card-box">
        <el-card>
          <div class="e-title">文章浏览量排行</div>
          <div style="height:350px" ref="articleRank">
          </div>
        </el-card>
      </el-col>
      <!-- 分类数据统计 -->
      <el-col :xs="24" :sm="24" :lg="8" class="card-box">
        <el-card>
          <div class="e-title">文章分类统计</div>
          <div style="height:350px" ref="category">
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CountTo from 'vue-count-to'
import { getHomeData } from "@/api/bloginfo";
import * as echarts from "echarts";
export default {
  components: {
    CountTo
  },
  created() {
    this.getData();
  },
  data: function() {
    return {
      loading: true,
      viewsCount: 0,
      messageCount: 0,
      userCount: 0,
      articleCount: 0,
      weekViewCount: {},
      ariticleRank: {},
      category: {}
    };
  },
  methods: {
    getData() {
      getHomeData().then(response => {
        this.viewsCount = response.data.viewsCount;
        this.messageCount = response.data.messageCount;
        this.userCount = response.data.userCount;
        this.articleCount = response.data.articleCount;

        // 一周访问量折线图
        if (response.data.uniqueViewDTOList != null) {
          let xAxisData = response.data.uniqueViewDTOList.map(item =>item.day );
          let seriesData = response.data.uniqueViewDTOList.map(item =>item.viewsCount );

          this.weekViewCount = echarts.init(this.$refs.weekViewCount, "macarons");
          this.weekViewCount.setOption({
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross"
              }
            },
            color: ["#3888fa"],
            legend: {
              data: ["访问量"]
            },
            grid: {
              left: "0%",
              right: "0%",
              bottom: "0%",
              top: "10%",
              containLabel: true
            },
            xAxis: {
              data: xAxisData,
              axisLine: {
                lineStyle: {
                  // 设置x轴颜色
                  color: "#666"
                }
              }
            },
            yAxis: {
              axisLine: {
                lineStyle: {
                  // 设置y轴颜色
                  color: "#048CCE"
                }
              }
            },
            series: [
              {
                name: "访问量",
                type: "line",
                data: seriesData,
                smooth: true,
                lineStyle: {
                  type: "dotted"
                },
                label: {
                  show: true,
                }
              }
            ]
          });

        }
        //文章分类饼图
        if (response.data.categoryDTOList != null) {
          let seriesData = response.data.categoryDTOList.map(item => ({value: item.articleCount, name: item.categoryName}));
          let legendData = response.data.categoryDTOList.map(item => item.categoryName);
          this.category = echarts.init(this.$refs.category, "macarons");
          this.category.setOption({
            color: [
              "#7EC0EE",
              "#FF9F7F",
              "#FFD700",
              "#C9C9C9",
              "#E066FF",
              "#C0FF3E"
            ],
            legend: {
              data: legendData,
              bottom: "bottom"
            },
            tooltip: {
              trigger: "item"
            },
            series: [
              {
                name: "文章分类",
                type: "pie",
                data: seriesData
              }
            ]
          });
        }
        //文章浏览量柱状图
        if (response.data.articleRankDTOList != null) {
          let seriesData = response.data.articleRankDTOList.map(item => item.viewsCount);
          let xAxisData = response.data.articleRankDTOList.map(item => item.articleTitle);
          this.ariticleRank = echarts.init(this.$refs.articleRank, "macarons");
          this.ariticleRank.setOption({
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross"
              }
            },
            color: ["#58AFFF"],
            grid: {
              left: "0%",
              right: "0%",
              bottom: "0%",
              top: "10%",
              containLabel: true
            },
            xAxis: {
              data: xAxisData
            },
            yAxis: {},
            series: [
              {
                name: "浏览量",
                type: "bar",
                data: seriesData,
                label: {
                  show: true,
                  position: 'inside',
                  color: "#fff",
                }
              }
            ]
          });
        }
        window.addEventListener("resize", () => {
          this.weekViewCount.resize();
          this.category.resize();
          this.ariticleRank.resize();
        });
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.card-panel{
  height: 108px;
  cursor: pointer;
  font-size: 12px;
  position: relative;
  overflow: hidden;
  color: #666;
  background: #fff;
  box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
  border-radius: 4px;
  border:1px solid #EBEEF5;
  &:hover {
    .card-panel-icon-wrapper {
      color: #fff;
    }

    .icon-view {
      background: #40c9c6;
    }

    .icon-comment {
      background: #36a3f7;
    }

    .icon-user {
      background: #f4516c;
    }

    .icon-article {
      background: #34bfa3
    }
  }

  .icon-view {
    color: #40c9c6;
  }

  .icon-comment {
    color: #36a3f7;
  }

  .icon-user {
    color: #f4516c;
  }

  .icon-article {
    color: #34bfa3
  }
  .card-panel-icon-wrapper {
    float: left;
    margin: 14px 0 0 14px;
    padding: 16px;
    transition: all 0.38s ease-out;
    border-radius: 6px;
  }
  .card-panel-icon {
    float: left;
    font-size: 48px;
  }
  .card-desc {
    float: right;
    font-weight: bold;
    margin: 26px;
    margin-left: 0px;

    .card-title {
      line-height: 18px;
      color: rgba(0, 0, 0, 0.45);
      font-size: 16px;
      margin-bottom: 12px;
    }

    .card-count {
      font-size: 20px;
    }
  }
}

.echarts {
  width: 100%;
  height: 100%;
}
.e-title {
  font-size: 13px;
  color: #202a34;
  font-weight: 700;
}
</style>
